import React from "react";
import { useLanguageTranslation } from "../hooks/useLanguageTranslation";
import { setFilteredDate, setSubmitDate } from "../redux/slice/sliceHome";
import { useDispatch, useSelector } from "react-redux";

const DateFilter = () => {
  const { getText } = useLanguageTranslation();
  const { filteredDate } = useSelector((state) => state.homeSlice);

  const dispatch = useDispatch();

  const handleSubmit = () => {
    dispatch(setSubmitDate(filteredDate));
  };

  const handleClear = () => {
    dispatch(setFilteredDate(""));
    dispatch(setSubmitDate("2060-12-12"));
  };
  return (
    <div className="form-group">
      <div className="form-inline">
        <input
          className="form-control"
          autoComplete="off"
          type="date"
          id="edit-title"
          name="title"
          size="30"
          maxLength="128"
          value={filteredDate}
          onChange={(e) => {
            dispatch(setFilteredDate(e.target.value));
          }}
        />
        <button
          className="quick-btn ml-2 quick-100"
          type="reset"
          id="edit-reset"
          onClick={handleSubmit}
        >
          {getText("Submit", "सबमिट करे")}
        </button>
        <button
          className="quick-btn clear-search-btn ml-2 quick-100"
          type="reset"
          id="edit-reset"
          onClick={handleClear}
        >
          {getText("Clear", "हटाएँ")}
        </button>
      </div>
    </div>
  );
};

export default DateFilter;
